export default function buildLogoutUrl({logout_url, client_id, callback_url}) {
  return `${logout_url}?client_id=${client_id}&redirect_uri=${callback_url}`
}
